import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface ItemQualityCheckListParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface ItemQualityCheckList {
    id?: any;
    tenantId: any;
    branchId: any;
    itemQlName:string;
    itemQlInsType:string;
    createdDate:Date;
    updatedDate:Date;
    createdBy:number;
    updatedBy:number;
    createdIP?:string;
    updatedIP?:string;
    itemQCTypeConfigMst?:any[];
    categoryName?:any;
    categoryId?:any;
    parameters?: ItemQualityCheckListParameter[];
    links?: any;
}
export interface ItemQCTypeConfigMst {
    id?: any;
    itemQlId?:number;
    itemCategoryId:number;
    tenantId: any;
    branchId: any;
}
export abstract class ItemQualityCheckListData {
    abstract list(url: string): Observable<ItemQualityCheckList[]>;
    abstract create(url: string, data: ItemQualityCheckList): Observable<ItemQualityCheckList[]>;
    abstract update(url: string, data: ItemQualityCheckList): Observable<ItemQualityCheckList>;
    abstract delete(url: string): Observable<any>;
}
